import * as React from 'react';
import Svg, {Path} from 'react-native-svg';
const SvgComponent = props => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={26}
    height={30}
    viewBox="0 0 26 30"
    {...props}
    fill="none"
    stroke="none">
    <Path
      fill={props.fill || '#444697'}
      fillRule="evenodd"
      d="M12.67 3.249c1.09 0 1.41 0 1.69.08.28.07.56.18.81.33.25.15.48.37 1.25 1.14l4.45 4.45c.77.77.99 1 1.14 1.25.15.25.27.52.33.81.07.28.08.6.08 1.69v8.66c0 1.19 0 2.01-.05 2.63-.05.61-.14.92-.25 1.14-.27.52-.69.95-1.22 1.22-.22.11-.53.2-1.14.25-.63.05-1.44.05-2.63.05H8.2c-1.19 0-2.01 0-2.63-.05-.61-.05-.92-.14-1.14-.25a2.82 2.82 0 0 1-1.22-1.22c-.11-.22-.2-.53-.25-1.14-.05-.63-.05-1.44-.05-2.63V8.549c0-1.19 0-2.01.05-2.63.05-.61.14-.92.25-1.14.27-.52.69-.95 1.22-1.22.22-.11.53-.2 1.14-.25.63-.05 1.44-.05 2.63-.05h4.48l-.01-.01Zm2.34-2.63c-.65-.15-1.31-.15-2.2-.15H8.13c-1.12 0-2.05 0-2.8.06-.78.06-1.5.2-2.18.55-1.05.53-1.9 1.39-2.44 2.44-.34.68-.48 1.4-.55 2.18-.06.75-.06 1.68-.06 2.8v13.22c0 1.12 0 2.05.06 2.8.06.78.2 1.5.55 2.18.53 1.05 1.39 1.9 2.44 2.44.68.34 1.4.48 2.18.55.75.06 1.68.06 2.8.06h9.04c1.12 0 2.05 0 2.8-.06.78-.06 1.5-.2 2.18-.55 1.05-.53 1.9-1.39 2.44-2.44.34-.68.48-1.4.55-2.18.06-.75.06-1.68.06-2.8v-8.86c0-.89 0-1.55-.15-2.2-.14-.57-.36-1.11-.67-1.61-.35-.57-.82-1.04-1.45-1.66l-.1-.1-4.45-4.45-.1-.1c-.63-.63-1.1-1.1-1.66-1.45a5.55 5.55 0 0 0-1.61-.67Zm-7.94 14.49c-.77 0-1.39.62-1.39 1.39 0 .77.62 1.39 1.39 1.39h8.37c.77 0 1.39-.62 1.39-1.39 0-.77-.62-1.39-1.39-1.39H7.07Zm0 5.58c-.77 0-1.39.62-1.39 1.39 0 .77.62 1.39 1.39 1.39h11.16c.77 0 1.39-.62 1.39-1.39 0-.77-.62-1.39-1.39-1.39H7.07Z"
      clipRule="evenodd"
    />
  </Svg>
);
export default SvgComponent;
